export default __webpack_public_path__ + "static/hero-image-ac6c3bd5c02f3fd1734cf492904a3efd.svg";